import { Box, Link, Button } from '@mui/material';
import { APPLE_PODCASTS_URL, SPOTIFY_URL, S3_FEED_URL } from '@constants/config';

// Custom Spotify SVG Badge
function SpotifyBadge() {
  return (
    <svg width="160" height="40" viewBox="0 0 160 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="160" height="40" rx="8" fill="#1DB954"/>
      <circle cx="20" cy="20" r="8" fill="white"/>
      <path d="M23.5 16.5C22.5 15.8 20.8 15.5 19 15.5C17.2 15.5 15.5 15.8 14.5 16.5M22.5 19C21.7 18.5 20.4 18.2 19 18.2C17.6 18.2 16.3 18.5 15.5 19M21.5 21.5C20.9 21.1 19.9 20.9 19 20.9C18.1 20.9 17.1 21.1 16.5 21.5" stroke="#1DB954" strokeWidth="1.2" strokeLinecap="round"/>
      <text x="34" y="25" fill="white" fontFamily="system-ui, -apple-system, sans-serif" fontSize="14" fontWeight="700">
        Listen on Spotify
      </text>
    </svg>
  );
}

export default function PodcastBadges() {
  const badgeStyle = {
    height: 40,
    borderRadius: 1,
    transition: 'opacity 0.2s',
    '&:hover': {
      opacity: 0.8
    }
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
      <Link href={APPLE_PODCASTS_URL} target="_blank" rel="noopener noreferrer">
        <Box
          component="img"
          src="https://tools.applemediaservices.com/api/badges/listen-on-apple-podcasts/badge/en-us?size=250x83"
          alt="Listen on Apple Podcasts"
          loading="lazy"
          decoding="async"
          sx={badgeStyle}
        />
      </Link>

      <Link href={SPOTIFY_URL} target="_blank" rel="noopener noreferrer" sx={{ display: 'block', height: 40 }}>
        <SpotifyBadge />
      </Link>

      <Link href={S3_FEED_URL} target="_blank" rel="noopener noreferrer">
        <Button
          variant="contained"
          sx={{
            height: 40,
            px: 2,
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            fontWeight: 700,
            '&:hover': {
              bgcolor: 'primary.dark',
              opacity: 0.9
            }
          }}
        >
          RSS Feed
        </Button>
      </Link>
    </Box>
  );
}
